import { createInsuranceProductPreset } from '../common/productPresetFactory'

const COPY_BY_PRESET = {
  default: {
    heroTitle: '가족 보호 목적과 장기 유지 가능성을 기준으로 종신보험을 검토합니다',
    heroSubtitle: '사망보장, 상속 대비, 납입 여력을 함께 확인해 필요한 준비인지 판단합니다.',
    formTitle: '종신보험 상담 신청',
  },
  'clean-form': {
    heroTitle: '종신보험, 목적에 맞는 준비인지 먼저 점검해보세요',
    heroSubtitle: '가족 보호 목적과 보험료 부담을 기준으로 지금 필요한 준비인지 점검합니다.',
    formTitle: '목적 점검 상담',
  },
  'hanwha-sections': {
    heroTitle: '가족 보호 목적에 맞는 종신보험 방향을 한 번에 정리합니다',
    heroSubtitle: '사망보장·상속·장기 유지까지 짚어, 우리 가족에 맞는 준비인지 함께 판단하실 수 있게 안내합니다.',
    formTitle: '종신보험 상담 신청',
  },
  'basic-template-4': {
    heroTitle: '사망보장, 상속 대비, 유지 가능성까지 함께 확인하세요',
    heroSubtitle: '사망보장, 상속 대비, 유지 가능성까지 꼭 확인할 기준을 먼저 정리해드립니다.',
    formTitle: '핵심 기준 상담',
  },
  'basic-template-5': {
    heroTitle: '목적이 분명한 종신보험 설계, 핵심만 전략적으로 안내합니다',
    heroSubtitle: '가족 보호 목적과 장기 유지 전략을 함께 점검해 꼭 필요한 방향으로 안내해드립니다.',
    formTitle: '1:1 종신 상담',
  },
}

export function getProductWholeLifePreset(presetKey = 'default') {
  const copy =
    COPY_BY_PRESET[presetKey]
    || (presetKey === 'lead-gen-fullbleed' ? COPY_BY_PRESET['hanwha-sections'] : undefined)
    || COPY_BY_PRESET.default
  return createInsuranceProductPreset('PRODUCT_WHOLE_LIFE', copy, presetKey)
}
